import { useState, useEffect } from 'react';
import { Container, Tabs, Tab } from 'react-bootstrap';
import HealthCheckLayout from '../../healthCheckLayout/HealthCheckLayout';
import PastAppointments from '../pastAppointments/PastAppointments';
import UpcomingAppointments from '../upcomingAppointments/UpcomingAppointments';
import './bookAnAppointmentDetails.css';

function BookAnAppointmentDetails() {
  const [key1, setKey1] = useState('');

  useEffect(() => {
    setKey1('upcomingAppointments');
  }, []);

  return (
    <HealthCheckLayout>
      <section className="bookAnAppointmentDetails bgLinghtGray">
        <Container>
          <Tabs
            id="controlled-tab-doctorAppoinment"
            activeKey={key1}
            transition
            onSelect={(k) => setKey1(k)}
            className="mb-3 customTabs"
          >
            <Tab eventKey="upcomingAppointments" title="Upcoming Appointments">
              <UpcomingAppointments />
            </Tab>
            <Tab eventKey="pastAppointments" title="Past Appointments">
              <PastAppointments />
            </Tab>
          </Tabs>
        </Container>
      </section>
    </HealthCheckLayout>
  );
}

export default BookAnAppointmentDetails;
